<template lang="html">
	<ul id="switcher">
		<li v-for="lang in site.langs" :key="lang" >
			<a :class="currentLang == lang ? 'router-link-exact-active' : ''" href="#" @click.prevent="changeLocation(lang)" :alt="lang">{{lang}}</a>
		</li>
	</ul>
</template>

<script>
	import loaderHandler  from '@/mixins/loaderHandler.js'
	
	export default {
		mixins: [loaderHandler],
		name: 'LangSwitcher',
		props: ['site', 'currentLang'],
		methods: {
			changeLocation(lang){
				if(lang == this.currentLang){
					return
				}
				this.$emit('setLang', lang);
				const id = this.$route.params.id;
				if(id){
					this.$router.push({ path: this.$route.meta[lang+'Path']+'/'+id, params: { id:id } });
				}else{
					this.$router.push({ path: this.$route.meta[lang+'Path']});
				}
				this.$i18n.locale = lang
			}
		},
		mounted(){
			this.displayComponent(0);
		},
	}
</script>

<style lang="scss">
ul#switcher{
	margin-left:0;
	display:block;
	@media screen and (min-width:769px){
		margin-left:3.4rem;
		display:inline-block;
	}
	li{
		margin-right: 0;
		a:before{
			content:"/";
			color:inherit;
			padding:0 .3em;
		}
		&:first-child{
			a:before{
				display:none;
			}
		}
	}
}
</style>
